import { render, staticRenderFns } from "./SoundWave.vue?vue&type=template&id=64ff8b33&scoped=true"
import script from "./SoundWave.vue?vue&type=script&lang=ts"
export * from "./SoundWave.vue?vue&type=script&lang=ts"
import style0 from "./SoundWave.vue?vue&type=style&index=0&id=64ff8b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff8b33",
  null
  
)

export default component.exports